// extracted by mini-css-extract-plugin
module.exports = {"source-card":"SourceCard_source-card__Lb1Bz","source-card--bordered":"SourceCard_source-card--bordered__GcaFA"};